import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {AssigneeChangeNotificationDataApiDto, NotificationBaseApiDto} from "../../../api/model/rest";
import {getUser} from "../../../store/view/user";
import {default as AssigneeChangeNotificationData} from "./AssigneeChangeNotificationData";

/**
 * Assignee change notification class.
 */
export default class AssigneeChangeNotification extends NotificationBase {

	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: AssigneeChangeNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): AssigneeChangeNotification {
		return new AssigneeChangeNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			AssigneeChangeNotificationData.fromJson(json.data as AssigneeChangeNotificationDataApiDto));
	}

	/**
	 * Display user Full name.
	 * @returns {string}
	 */
	displayCreatorName() {
		return getUser(this.data.creator.id).map(u => u.getDisplayName()).getOrElse(this.data.creator.id);
	}

	/**
	 * Display previous assignees full names
	 * @return {string}
	 */
	displayPreviousAssignees() {
		let previousAssignees = this.data.previousAssigneesIds.map(id => getUser(id).map(u => u.getDisplayName()).getOrElse("")).join(", ");
		return previousAssignees ? previousAssignees : "Unassigned";
	}

	/**
	 * Display current assignees full names
	 * @return {string}
	 */
	displayCurrentAssignees() {
		let currentAssignees = this.data.currentAssigneesIds.map(id => getUser(id).map(u => u.getDisplayName()).getOrElse("")).join(", ");
		return currentAssignees ? currentAssignees : "Unassigned";
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new AssigneeChangeNotification(id, dateTime, read, type, data);
	}
}